import { Pipe, PipeTransform } from '@angular/core';
import { Estimate } from '@interfaces/Estimate';
import { TreeNode } from 'primeng/api';

@Pipe({
  name: 'categoryCode'
})
export class CategoryCodePipe implements PipeTransform {
  public transform(level1Node: TreeNode, estimate: Estimate, level2Node?: TreeNode) {
    let categoryCode = '-';

    if (level2Node) {
      const structures = estimate.structures.filter(
        s => s.level1Id === level1Node.data.id && s.level2Id === level2Node.data.id
      );
      if (structures.length > 0) {
        const structure = structures[0];
        if (structure.categoryGroup) {
          categoryCode = structure.categoryGroup.code;
        }
      }
    } else {
      const structures = estimate.structures.filter(s => s.level1Id === level1Node.data.id);
      for (const structure of structures) {
        if (structure.categoryGroup) {
          categoryCode = structure.categoryGroup.code;
        }
      }
    }

    return categoryCode;
  }
}
